// registerPlugins(app) — order matters: pinia → router → vuetify (doc 04 §2.4).
import type { App } from 'vue'
import { pinia } from './pinia'
import vuetify from './vuetify'
import router from '@/router'

export function registerPlugins(app: App): void {
  app.use(pinia)
  app.use(router)
  app.use(vuetify)
}
